import React from 'react'
import { HotspotStage, Pin, REGION_STYLES, RegionLabel, RegionShape } from './HotspotStage'
import { hitRegion } from './geometry'

/**
 * Read-only hotspot: every region outlined (correct in green, distractors neutral) with its
 * label, plus the student's pins colored by whether they landed in a correct region.
 * Selections picked from the list (no x/y) are listed by the page around it.
 */
export const HotspotViewer = ({ imageUrl, imageAlt, regions = [], selections = [] }) => {
  if (!imageUrl) {
    return <div className="text-muted">No image has been chosen for this hotspot.</div>
  }
  // Numbered by position among all selections so they match the page's breakdown list.
  const pins = selections
    .map((sel, i) => ({ ...sel, number: i + 1 }))
    .filter(sel => sel.x !== undefined)
  return (
    <HotspotStage
      imageUrl={imageUrl}
      imageAlt={imageAlt}
      stageProps={{ style: { maxWidth: 640 } }}
      overlay={regions.map(region => (
        <RegionShape
          key={region.guid}
          region={region}
          style={region.correct ? REGION_STYLES.correct : REGION_STYLES.distractor}
        />
      ))}
    >
      {regions.map(region => <RegionLabel key={region.guid} region={region} />)}
      {pins.map(pin => {
        const region = hitRegion(regions, pin.x, pin.y)
        return (
          <Pin
            key={pin.number}
            pin={pin}
            number={pin.number}
            status={region && region.correct ? 'correct' : 'incorrect'}
          />
        )
      })}
    </HotspotStage>
  )
}
